import { render, staticRenderFns } from "./ShowClientBuildings.vue?vue&type=template&id=7ddbe8e8"
import script from "./ShowClientBuildings.vue?vue&type=script&lang=js"
export * from "./ShowClientBuildings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports